import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar/navbar.component';
import { RouterModule } from '@angular/router';
import { SlideshowComponent } from './slideshow/slideshow.component';
import { PeliculasPosterGridComponent } from './peliculas-poster-grid/peliculas-poster-grid.component';
import { StarratingComponent } from './starrating/starrating.component';
import { RatingModule } from 'ng-starrating';
import { PipesModule } from '../pipes/pipes.module';
import { CastSlideshowComponent } from './cast-slideshow/cast-slideshow.component';
import { SimilarsSlideshowComponent } from '././similars-slideshow/similars-slideshow.component';
import { SlidePeliculasSimilaresComponent } from './slide-peliculas-similares/slide-peliculas-similares.component';



@NgModule({
  declarations: [NavbarComponent,
                SlideshowComponent,
                PeliculasPosterGridComponent,
                StarratingComponent,
                CastSlideshowComponent,
                SimilarsSlideshowComponent,
                SlidePeliculasSimilaresComponent],
  imports: [
    CommonModule,
    RouterModule,
    RatingModule,
    PipesModule
  ],
  exports: [
    NavbarComponent,
    SlideshowComponent,
    PeliculasPosterGridComponent,
    StarratingComponent,
    CastSlideshowComponent,
    SimilarsSlideshowComponent,
    SlidePeliculasSimilaresComponent
  ]
})
export class ComponentsModule { }
